module.exports = __webpack_public_path__ + "img/techies.b34c6139.jpg";